import { refreshAuthSession } from '../api/auth.js';

/** 租户相关通知点击跳转 */
export function navigateForTenantNotification(type, navigate) {
  const go = (path) => {
    if (typeof navigate === 'function') {
      navigate(path);
      return;
    }
    window.location.assign(path);
  };

  switch (type) {
    case 'TENANT_MEMBER_PENDING':
      go('/system-management/tenant-member-applications');
      return true;
    case 'TENANT_PROVISION_PENDING':
      go('/system-management/tenant?tab=provision');
      return true;
    case 'TENANT_MEMBER_APPROVED':
    case 'TENANT_PROVISION_APPROVED':
      refreshAuthSession()
        .then(() => go('/welcome'))
        .catch(() => go('/onboarding/tenant'));
      return true;
    case 'TENANT_MEMBER_REJECTED':
    case 'TENANT_PROVISION_REJECTED':
      go('/onboarding/tenant');
      return true;
    default:
      return false;
  }
}
